export class CoreService {
  private readonly SentimentsIdName = 'sentiments.sentimentsId';
  private readonly CollapsedModeName = 'sentiments.switchCollapsedMode';
  private sentimentsId: string;
  private collapsedMode: boolean;
  private shouldTrackBugReportFormEntry: boolean = true;

  constructor() {
    const id = window.sessionStorage.getItem(this.SentimentsIdName);
    const status = window.sessionStorage.getItem(this.CollapsedModeName);
    if (id) {
      this.sentimentsId = id;
    }

    if (status) {
      this.collapsedMode = status === 'true';
    }
  }

  setSentimentsId(id: string): void {
    this.sentimentsId = id;
    window.sessionStorage.setItem(this.SentimentsIdName, id);

    // mark it as new session after sentimentsId is generated.
    this.shouldTrackBugReportFormEntry = true;
  }

  getSentimentsId(): string {
    return this.sentimentsId;
  }

  setCollapsedMode(status: boolean): void {
    this.collapsedMode = status;
    window.sessionStorage.setItem(this.CollapsedModeName, status.toString());
  }

  getCollapsedMode(): boolean {
    return this.collapsedMode;
  }

  hasBugReportFormEntryTracked(): boolean {
    return this.shouldTrackBugReportFormEntry;
  }

  disableBugReportFormEntryTracking(): void {
    this.shouldTrackBugReportFormEntry = false;
  }
}
